import React from 'react';

import { Button } from 'rsuite';
import { useIntl } from 'react-intl';
import { Rbac } from '../../common/Rbac';
import {
  CleanDeliveryOrder,
  RbacObject,
} from '../../../export-types/cleaned-types';
import { ModalsService } from '../../../services/modals.service';
import { MarkAsReceivedBulkModal } from './sent-to-russia-tab/mark-as-received-bulk-modal';
import { cache } from 'swr/_internal';
import { mutate as globalMutate } from 'swr';
import { DeliveriesReportModal } from './sent-to-russia-tab/deliveries-report-modal';
import { useProfile } from '../../../api/profile';

type Props = {
  selectAllOrders: boolean;
  setSelectAllOrders: (value: boolean) => void;
  selectedOrders: CleanDeliveryOrder[];
};

export const DeliveryOrdersScreenInTransitBlock = ({
  selectAllOrders,
  setSelectAllOrders,
  selectedOrders,
}: Props) => {
  const intl = useIntl();
  const { data: profile } = useProfile();

  return (
    <>
      {profile?.accesses?.includes('warehouseRussia') && (
        <Rbac object={RbacObject.Transportation} action={'write:receive'}>
          <div className={'d-flex gap-2 mleft-auto'}>
            <div className={'d-flex gap-1 fs-18 fw-600 align-items-center'}>
              <span>
                {intl.formatMessage({
                  id: 'deliveryOrder.all',
                  defaultMessage: 'Все',
                  description: 'Надпись на вкладке',
                })}
              </span>
              <input
                className="form-check-input border-2 p-2 cursor-pointer mb-1"
                type="checkbox"
                checked={selectAllOrders}
                onChange={() => {
                  setSelectAllOrders(!selectAllOrders);
                }}
              />
            </div>
            <div className={'my-auto'}>
              <Button
                className={'btn btn-success'}
                disabled={!selectedOrders.length}
                onClick={() => {
                  ModalsService.createModal(MarkAsReceivedBulkModal, {
                    deliveryOrders: selectedOrders,
                  }).then(() => {
                    for (const key of cache.keys()) {
                      globalMutate(key, undefined, true);
                    }
                  });
                }}
              >
                {intl.formatMessage({
                  id: 'deliveryOrder.moveToReceivedInRussia',
                  defaultMessage: 'Принять на склад',
                  description: 'Надпись на вкладке',
                })}
              </Button>
            </div>
          </div>
        </Rbac>
      )}
    </>
  );
};
